import Header from "../../layout/Header/Header";
import PaymentSuccessContent from "./PaymentSuccessContent/PaymentSuccessContent";

const PaymentSuccess = () => {
  return (
    <main>
      <Header withoutSteps />

      <PaymentSuccessContent />
    </main>
  );
};

export default PaymentSuccess;
